export const CONDITION = "condition";
export const PRIVACY = "privacy";
export const LEGAL = "legal";
